
import './App.css';
import Home from './pages';
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import Impressumpage from './pages/impressum';


function App() {
  return (
    <Router>
      <Switch>
      <Route path="/" component={Home} exact />
      <Route path="/impressum" component={Impressumpage} exact />
      </Switch>
    </Router>
  );
}

export default App;
